const Constants = {
  PERSONAL_NAME_MAX_LENGTH: 120,
  CORP_NAME_MAX_LENGTH: 250,
};

export default Constants;
